import { render, staticRenderFns } from "./brandAnalysis.vue?vue&type=template&id=4cc74f2d"
import script from "./brandAnalysis.vue?vue&type=script&lang=js"
export * from "./brandAnalysis.vue?vue&type=script&lang=js"
import style0 from "./brandAnalysis.vue?vue&type=style&index=0&id=4cc74f2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports